/**
 * The business once ran three storefronts: retail, stock and factory (container).
 * Retail and stock were retired, and their routes were removed from the route
 * table in src/router.js. This predicate exists so old bookmarks and inbound
 * links to those storefronts land on the factory store instead of the 404 page.
 *
 * It deliberately anchors on the first path segment. A bare substring test
 * (`to.path.includes('stock')`) also swallows the admin and account pages that
 * are still very much alive — /admin/stock-orders, /admin/stockManagement,
 * /admin/retail-orders, /scan/stocktake and friends.
 */
const RETIRED_STOREFRONTS = /^\/(?:retail|stock)(?:\/|$)|^\/(?:login|register)-retail(?:\/|$)/

export function isRetiredStoreRoute (path) {
  if (!path) return false
  return RETIRED_STOREFRONTS.test(path)
}
